import React from 'react'

/**
 * 页面授权的共享内容容器。
 * 独立授权页和 Profile 里的嵌入面板都通过这里承载当前页面、状态提示和授权记录，
 * 避免两套布局随着需求变更逐渐不一致。
 */
const VibeOwnerAccessPermissionPanel = ({ children }) => (
    <div className="vibe-owner-access-permission-panel">
        {children}
    </div>
)

export default VibeOwnerAccessPermissionPanel
